// CONTACT PAGE ******************************** 
$(document).ready(function() {            


   $("#ContactFormSection .input.five").click(function () {
      $("#FormInner input, #FormInner textarea").val("");
   });


});  